module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_6005.030f2e3c.png";